import {AWDStatus, matchAWDStatusByType} from 'ApplicationEntry/models/AWDStatus/AWDStatus';
import * as G from 'ApplicationEntry/models/AWDStatus/GroupAWDStatus';
import * as NY from 'ApplicationEntry/models/AWDStatus/NewYorkAWDStatus';
import * as O from 'ApplicationEntry/models/AWDStatus/OrdinaryAWDStatus';
import {UpdateWork} from 'ApplicationEntry/models/AWDStatus/UpdateWork';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum AWDStatusActionType {
  CHANGE_WORK_TYPE = 'awdStatus/CHANGE_WORK_TYPE',
  CHANGE_WORK_TYPE2 = 'awdStatus/CHANGE_WORK_TYPE2',
  CHANGE_WORK_TYPE3 = 'awdStatus/CHANGE_WORK_TYPE3',
  CHANGE_STATUS = 'awdStatus/CHANGE_STATUS',
  CHANGE_STATUS2 = 'awdStatus/CHANGE_STATUS2',
  CHANGE_STATUS3 = 'awdStatus/CHANGE_STATUS3',
  CHANGE_UNDERWRITER = 'awdStatus/CHANGE_UNDERWRITER',
  CHANGE_UNDERWRITER2 = 'awdStatus/CHANGE_UNDERWRITER2',
  CHANGE_UNDERWRITER3 = 'awdStatus/CHANGE_UNDERWRITER3',
  CHANGE_COMMENTS = 'awdStatus/CHANGE_COMMENTS',
  CHANGE_COMMENTS2 = 'awdStatus/CHANGE_COMMENTS2',
  CHANGE_COMMENTS3 = 'awdStatus/CHANGE_COMMENTS3',
  CHANGE_OVERRIDE = 'awdStatus/CHANGE_OVERRIDE',
  CHANGE_OVERRIDE2 = 'awdStatus/CHANGE_OVERRIDE2',
  CHANGE_OVERRIDE3 = 'awdStatus/CHANGE_OVERRIDE3',
  GET_WORK_TYPES = 'awdStatus/GET_WORK_TYPES',
  GET_STATUS = 'awdStatus/GET_STATUS',
  GET_UNDERWRITER = 'awdStatus/GET_UNDERWRITER',
  CHANGE_WORK_TYPE_LIST = 'awdStatus/CHANGE_WORK_TYPE_LIST',
  CHANGE_STATUS_LIST = 'awdStatus/CHANGE_STATUS_LIST',
  CHANGE_UNDERWRITER_LIST = 'awdStatus/CHANGE_UNDERWRITER_LIST',
  UPDATE_WORK = 'awdStatus/UPDATE_WORK',
  RESET = 'awdStatus/RESET',
}

export const isAWDStatusAction = (action: any): action is AWDStatusAction =>
  action.type in reverseEnum(AWDStatusActionType);

export const changeWorkType = (workType: string) => createAction(AWDStatusActionType.CHANGE_WORK_TYPE, {workType});
export const changeWorkType2 = (workType2: string) => createAction(AWDStatusActionType.CHANGE_WORK_TYPE2, {workType2});
export const changeWorkType3 = (workType3: string) => createAction(AWDStatusActionType.CHANGE_WORK_TYPE3, {workType3});
export const changeStatus = (status: string) => createAction(AWDStatusActionType.CHANGE_STATUS, {status});
export const changeStatus2 = (status2: string) => createAction(AWDStatusActionType.CHANGE_STATUS2, {status2});
export const changeStatus3 = (status3: string) => createAction(AWDStatusActionType.CHANGE_STATUS3, {status3});
export const changeUnderwriter = (underwriter: string) =>
  createAction(AWDStatusActionType.CHANGE_UNDERWRITER, {underwriter});
export const changeUnderwriter2 = (underwriter2: string) =>
  createAction(AWDStatusActionType.CHANGE_UNDERWRITER2, {underwriter2});
export const changeUnderwriter3 = (underwriter3: string) =>
  createAction(AWDStatusActionType.CHANGE_UNDERWRITER3, {underwriter3});
export const changeComments = (comments: string) => createAction(AWDStatusActionType.CHANGE_COMMENTS, {comments});
export const changeComments2 = (comments2: string) => createAction(AWDStatusActionType.CHANGE_COMMENTS2, {comments2});
export const changeComments3 = (comments3: string) => createAction(AWDStatusActionType.CHANGE_COMMENTS3, {comments3});
export const changeOverride = () => createAction(AWDStatusActionType.CHANGE_OVERRIDE);
export const changeOverride2 = () => createAction(AWDStatusActionType.CHANGE_OVERRIDE2);
export const changeOverride3 = () => createAction(AWDStatusActionType.CHANGE_OVERRIDE3);
export const changeWorkTypeList = (workTypeList: Async<string[]>) =>
  createAction(AWDStatusActionType.CHANGE_WORK_TYPE_LIST, {workTypeList});
export const changeStatusList = (statusList: Async<string[]>) =>
  createAction(AWDStatusActionType.CHANGE_STATUS_LIST, {statusList});
export const changeUnderwriterList = (underwriterList: Async<string[]>) =>
  createAction(AWDStatusActionType.CHANGE_UNDERWRITER_LIST, {underwriterList});
export const getWorkTypeList = (businessArea: string) =>
  createAction(AWDStatusActionType.GET_WORK_TYPES, {businessArea});
export const getStatusList = (businessArea: string, workType: string) =>
  createAction(AWDStatusActionType.GET_STATUS, {businessArea, workType});
export const getUnderwriterList = () => createAction(AWDStatusActionType.GET_UNDERWRITER);
export const updateWork = (work: UpdateWork) => {
  return createAction(AWDStatusActionType.UPDATE_WORK, {work});
};
export const reset = () => createAction(AWDStatusActionType.RESET);

export type AWDStatusAction =
  | ReturnType<typeof changeWorkType>
  | ReturnType<typeof changeWorkType2>
  | ReturnType<typeof changeWorkType3>
  | ReturnType<typeof changeStatus>
  | ReturnType<typeof changeStatus2>
  | ReturnType<typeof changeStatus3>
  | ReturnType<typeof changeUnderwriter>
  | ReturnType<typeof changeUnderwriter2>
  | ReturnType<typeof changeUnderwriter3>
  | ReturnType<typeof changeComments>
  | ReturnType<typeof changeComments2>
  | ReturnType<typeof changeComments3>
  | ReturnType<typeof changeOverride>
  | ReturnType<typeof changeOverride2>
  | ReturnType<typeof changeOverride3>
  | ReturnType<typeof changeWorkTypeList>
  | ReturnType<typeof changeStatusList>
  | ReturnType<typeof changeUnderwriterList>
  | ReturnType<typeof getWorkTypeList>
  | ReturnType<typeof getStatusList>
  | ReturnType<typeof getUnderwriterList>
  | ReturnType<typeof updateWork>
  | ReturnType<typeof reset>;

type AWDStatusState = AWDStatus;

export default (state: AWDStatusState, action: AWDStatusAction): AWDStatusState => {
  switch (action.type) {
    case AWDStatusActionType.CHANGE_WORK_TYPE:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeWorkType(action.payload.workType),
        Group: G.changeWorkType(action.payload.workType),
        NewYork: NY.changeWorkType(action.payload.workType),
      })(state);
    case AWDStatusActionType.CHANGE_WORK_TYPE2:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeWorkType2(action.payload.workType2),
        Group: G.changeWorkType2(action.payload.workType2),
        NewYork: NY.changeWorkType(action.payload.workType2),
      })(state);
    case AWDStatusActionType.CHANGE_WORK_TYPE3:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeWorkType3(action.payload.workType3),
        Group: G.changeWorkType3(action.payload.workType3),
        NewYork: NY.changeWorkType(action.payload.workType3),
      })(state);
    case AWDStatusActionType.CHANGE_STATUS:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeStatus(action.payload.status),
        Group: G.changeStatus(action.payload.status),
        NewYork: NY.changeStatus(action.payload.status),
      })(state);
    case AWDStatusActionType.CHANGE_STATUS2:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeStatus2(action.payload.status2),
        Group: G.changeStatus2(action.payload.status2),
        NewYork: NY.changeStatus2(action.payload.status2),
      })(state);
    case AWDStatusActionType.CHANGE_STATUS3:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeStatus3(action.payload.status3),
        Group: G.changeStatus3(action.payload.status3),
        NewYork: NY.changeStatus3(action.payload.status3),
      })(state);
    case AWDStatusActionType.CHANGE_UNDERWRITER:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeUnderwriter(action.payload.underwriter),
        Group: G.changeUnderwriter(action.payload.underwriter),
        NewYork: NY.changeUnderwriter(action.payload.underwriter),
      })(state);
    case AWDStatusActionType.CHANGE_UNDERWRITER2:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeUnderwriter2(action.payload.underwriter2),
        Group: G.changeUnderwriter2(action.payload.underwriter2),
        NewYork: NY.changeUnderwriter2(action.payload.underwriter2),
      })(state);
    case AWDStatusActionType.CHANGE_UNDERWRITER3:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeUnderwriter3(action.payload.underwriter3),
        Group: G.changeUnderwriter3(action.payload.underwriter3),
        NewYork: NY.changeUnderwriter3(action.payload.underwriter3),
      })(state);
    case AWDStatusActionType.CHANGE_COMMENTS:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeComments(action.payload.comments),
        Group: G.changeComments(action.payload.comments),
        NewYork: NY.changeComments(action.payload.comments),
      })(state);
    case AWDStatusActionType.CHANGE_COMMENTS2:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeComments2(action.payload.comments2),
        Group: G.changeComments2(action.payload.comments2),
        NewYork: NY.changeComments2(action.payload.comments2),
      })(state);
    case AWDStatusActionType.CHANGE_COMMENTS3:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeComments3(action.payload.comments3),
        Group: G.changeComments3(action.payload.comments3),
        NewYork: NY.changeComments3(action.payload.comments3),
      })(state);
    case AWDStatusActionType.CHANGE_OVERRIDE:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeOverride(),
        Group: G.changeOverride(),
        NewYork: NY.changeOverride(),
      })(state);
    case AWDStatusActionType.CHANGE_OVERRIDE2:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeOverride(),
        Group: G.changeOverride(),
        NewYork: NY.changeOverride(),
      })(state);
    case AWDStatusActionType.CHANGE_OVERRIDE3:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeOverride(),
        Group: G.changeOverride(),
        NewYork: NY.changeOverride(),
      })(state);
    case AWDStatusActionType.CHANGE_WORK_TYPE_LIST:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeWorkTypeList(action.payload.workTypeList),
        Group: G.changeWorkTypeList(action.payload.workTypeList),
        NewYork: NY.changeWorkTypeList(action.payload.workTypeList),
      })(state);
    case AWDStatusActionType.CHANGE_STATUS_LIST:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeStatusList(action.payload.statusList),
        Group: G.changeStatusList(action.payload.statusList),
        NewYork: NY.changeStatusList(action.payload.statusList),
      })(state);
    case AWDStatusActionType.CHANGE_UNDERWRITER_LIST:
      return matchAWDStatusByType<AWDStatus>({
        Ordinary: O.changeUnderwriterList(action.payload.underwriterList),
        Group: G.changeUnderwriterList(action.payload.underwriterList),
        NewYork: NY.changeUnderwriterList(action.payload.underwriterList),
      })(state);
    case AWDStatusActionType.GET_WORK_TYPES:
      return matchAWDStatusByType<AWDStatus>({
        Group: G.changeWorkTypeList(new Loading()),
        Ordinary: O.changeWorkTypeList(new Loading()),
        NewYork: NY.changeWorkTypeList(new Loading()),
      })(state);
    case AWDStatusActionType.GET_STATUS:
      return matchAWDStatusByType<AWDStatus>({
        Group: G.changeStatusList(new Loading()),
        Ordinary: O.changeStatusList(new Loading()),
        NewYork: NY.changeStatusList(new Loading()),
      })(state);
    case AWDStatusActionType.GET_UNDERWRITER:
      return matchAWDStatusByType<AWDStatus>({
        Group: G.changeUnderwriterList(new Loading()),
        Ordinary: O.changeUnderwriterList(new Loading()),
        NewYork: NY.changeUnderwriterList(new Loading()),
      })(state);
    case AWDStatusActionType.RESET:
      return matchAWDStatusByType<AWDStatus>({
        Group: G.resetApp(),
        Ordinary: O.resetApp(),
        NewYork: NY.resetApp(),
      })(state);
    default:
      return state;
  }
};
